import React from 'react';
import CtServiceTable from './table/CtServiceTable';

const ServiceContent: React.FC = () => {
  return <CtServiceTable />;
};

export default ServiceContent;
